import {createPortal} from 'react-dom';

import ROUTE_PATHS from '@/consts/route/routePaths';
import useLocationPathname from '@/hooks/useLocationPathname';
import {twx} from '@/utils/tailwindUtils';
import HomePageGreeting from '@/views/Greeting/HomePageGreeting';

import useGreetingPortal from './useGreetingPortal';

const TopBannerGreeting = ({greetingRef, animationClassName, animationStyle}) => {
    const {pathname} = useLocationPathname();
    const isHomePage = pathname === ROUTE_PATHS.HOME_PAGE;
    const greetingPortal = useGreetingPortal(isHomePage);

    return (
        <>
            <HomePageGreeting
                className={twx(
                    'absolute left-0 top-0 w-full px-4 pr-22 text-start pt-safe-offset-4 md:px-8 ml:px-4',
                    {'ml:hidden': isHomePage},
                    {'md:px-8 ml:pl-16 ml:pr-32': !isHomePage},
                    {[animationClassName]: isHomePage}
                )}
                style={animationStyle}
                ref={greetingRef}
            />
            {greetingPortal &&
                createPortal(
                    <HomePageGreeting
                        className={twx(
                            'hidden font-bold tracking-04 pt-safe-offset-4 md:pt-safe-offset-8 ml:block ml:pt-0',
                            {
                                [animationClassName]: isHomePage,
                            }
                        )}
                        style={animationStyle}
                        ref={greetingRef}
                    />,
                    greetingPortal
                )}
        </>
    );
};

export default TopBannerGreeting;
